import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Leaf } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate("/"); return; }

    (async () => {
      try {
        const { data } = await api.post("/admin/google-session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(data);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true });
      } catch (err) {
        setError(err.response?.data?.detail || "Accesso non autorizzato");
        setTimeout(() => navigate("/"), 2500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4" data-testid="auth-callback">
      <div className="h-14 w-14 rounded-2xl bg-primary text-primary-foreground grid place-items-center animate-pulse">
        <Leaf className="h-7 w-7" />
      </div>
      {error ? (
        <p className="text-destructive text-sm max-w-sm text-center px-4">{error}</p>
      ) : (
        <p className="text-muted-foreground text-sm">Verifica accesso amministratore…</p>
      )}
    </div>
  );
}
